import api from '../../lib/api';

export default async function createInvoice(data): string {
  try {
    const response = await api.postWithoutToken('payments/invoices', data);
    return response.data.invoices[0];
  } catch (err) {
    throw err;
  }
}



// WEBPACK FOOTER //
// ./src/services/cart/createInvoice.js